import { render, staticRenderFns } from "./index.vue?vue&type=template&id=fc8bbcee&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=fc8bbcee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc8bbcee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\colocess_web_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fc8bbcee')) {
      api.createRecord('fc8bbcee', component.options)
    } else {
      api.reload('fc8bbcee', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=fc8bbcee&scoped=true&", function () {
      api.rerender('fc8bbcee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/header-aside/components/panel-search/components/panel-search-item/index.vue"
export default component.exports